<template>
  <div>
    <div class="kye-dialog-body">
      <kye-form :model="formModel" ref="form">
        <kye-form-item label="分组名称" :rules="$rule.str('请输入分组名称', true)">
          <el-input v-model="formModel.groupName" :maxlength="8" placeholder="可输入8个字符"></el-input>
        </kye-form-item>
      </kye-form>
    </div>
    <div class="el-dialog__footer">
      <kye-button type="primary" @click="submit">保存</kye-button>
      <kye-button  @click="cancel">取消</kye-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      dialogData: Object
    },
    data() {
      return {
        formModel: {
          groupName: ''
        }
      }
    },
    created () {
      if (this.dialogData) {
        Object.assign(this.formModel, this.dialogData)
      }
    },
    methods: {
      async submit () {
        try {
          const url = this.dialogData ? 'system.homeModuleGroup.update' : 'system.homeModuleGroup.save'
          const params = {
            userId: this.$store.state.user.id,
            groupName: this.formModel.groupName
          }
          if (this.dialogData) {
            params.id = this.dialogData.id
          }
          await this.$http(url, params)
          this.$message.success('保存成功')
          this.$emit('updateGroup')
          this.$emit('close')
        } catch (error) {
          console.error(error)
        }
      },
      cancel () {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/add-group-dialog.vue